import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

import { Swiper as SwiperClass, Pagination, Navigation } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'


//THX TO THIS Comment, the navigation works correctly: https://github.com/surmon-china/vue-awesome-swiper/issues/680#issuecomment-776206178
// import style
import 'swiper/swiper-bundle.min.css'

SwiperClass.use([Pagination, Navigation])
Vue.use(getAwesomeSwiper(SwiperClass))

Vue.prototype.$http = axios

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
